/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Runtime booking configuration exposed to the frontend (planning horizon + display toggles).
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface BookingConfig { 
    bookingSlotsRangeInDays: number;
    utilizationColorCoding: boolean;
}
export const BookingConfig_bookingSlotsRangeInDays_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingConfig_utilizationColorCoding_Validators: ValidatorFn[] =
    [  Validators.required, ];


